// TODO: check and remove this file.
import React from 'react';
import { TrevorIcon } from '@trevor/ui-components';
import { groupRowsIntoCellChunks } from '@/features/drilldown/utils';
import { getRowsRequestNewTabUrl } from '@/util/helpers/ajax-helpers';
import css from '../css/module/new-world.css';
import DrilldownOption from './DrilldownOption';
import RowDrilldownRef from './RowDrilldownRef';

const DataTableRenderer = () => null;

class DataTableBuilder {
  constructor(buildTable = null) {
    this._buildTable = buildTable; // for recursively building table for drilldown
    this._includeHeaders = !!buildTable;
    this.buildDrilldownOptions = this.buildDrilldownOptions.bind(this);
  }

  build(
    dataTable,
    expandedRows = {},
    expandClicked = null,
    parentRowDrilldownRef = null,
  ) {
    return this.buildRowsContent(
      dataTable,
      expandedRows,
      expandClicked,
      parentRowDrilldownRef,
    );
  }

  buildDrilldownOptions(
    dataTable,
    dtRow,
    parentRowDrilldownRef,
    rowExpanded,
    expandClicked,
  ) {
    const renderedFks = [];
    const options = dataTable.drilldownOptions().sort(DrilldownOption.sortFunc);

    options.forEach((option, index) => {
      const fkExpanded = rowExpanded.find((e) => e.option() === option);
      const rowDrilldownRef = new RowDrilldownRef(
        dtRow,
        option,
        parentRowDrilldownRef,
      );
      renderedFks.push(
        <tr key={index}>
          <td
            key="expand"
            className="no-border"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <TrevorIcon
              size="16"
              name="chevron-right"
              style={{
                transform: fkExpanded ? 'rotate(90deg)' : '',
                cursor: 'pointer',
              }}
              onClick={expandClicked(
                rowDrilldownRef,
                fkExpanded,
                dataTable.headings().map((h) => h.columnName()),
                dataTable.aliases(),
              )}
            />
          </td>
          <td key="fk" className="expand-option">
            {option.html()}
          </td>
          {!fkExpanded || !fkExpanded.rowRequestId() ? null : (
            <td className="no-border">
              <button
                className="btn btn-outline-dark btn-sm margin-5"
                onClick={() =>
                  window.open(
                    getRowsRequestNewTabUrl(fkExpanded.rowRequestId()),
                  )
                }
              >
                <span className="glyphicon glyphicon-new-window" /> Open results
                in new tab
              </button>
            </td>
          )}
        </tr>,
      );
      //
      // if the foreign key is expanded (i.e. the + next next to it has been clicked) show that content below this row too
      //
      if (fkExpanded) {
        // recursively build the table for the expanded foreign key
        const dt = this._buildTable(
          fkExpanded.dataTable(),
          null,
          fkExpanded.loading(),
          `expanded-cell ${css.expandedCell}`,
          rowDrilldownRef,
          expandClicked,
          fkExpanded.expandedRows(),
          fkExpanded.errorMsg(),
        );
        renderedFks.push(
          <tr key={`${index}expanded`}>
            <td className="no-border" />
            <td className="expanded-cell">{dt}</td>
          </tr>,
        );
      }
    });
    return renderedFks;
  }

  buildRowsContent(dataTable, expandedRows = {}) {
    // group rows into chunks (handles merging of vertical cells when joining two tables)
    const rows = groupRowsIntoCellChunks(dataTable, expandedRows);

    // build each row of the data table
    return <DataTableRenderer rows={rows} dataTable={dataTable} />;
  }
}

export default DataTableBuilder;
